import { useState, useEffect, useRef } from 'react';

// material-ui
import {
    IconButton,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    Typography
} from '@mui/material';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';

// project imports
import { SLOT_DURATION } from 'store/constant';
import VenueContent from './VenueContent';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';

export default function VenueSettings({ venueUuid, venueDetails, setDetailsReload }) {

    const [cancellationCheck, setCancellationCheck] = useState(venueUuid ? venueDetails.cancellation_enable ? true : false : false);
    const [open, setOpen] = useState(false);
    const [reload, setReload] = useState(false);
    const [selectedContent, setSelectedContent] = useState(null);
    const [slotDuration, setSlotDuration] = useState(venueUuid ? venueDetails.slot_duration : '');
    const [rows, setRows] = useState([]);
    const [initVal, setInitVal] = useState(1);
    const initRef = useRef(initVal);

    const handleClickOpen = (type) => {
        setSelectedContent(type);
        setTimeout(() => {
            setOpen(true);
        }, 500);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedContent(null);
    };

    const handleCancellation = (event) => {
        setCancellationCheck(event.target.checked);
    };

    const changeDuration = (e) => {
        setSlotDuration(e.target.value);
    };

    const getSettingsHandler = (response) => {
        setRows(response.data);
    };

    const getSettingsApi = useApi(VenueService.getVenueSettings, getSettingsHandler);
    const updateVenueApi = useApi(VenueService.updateVenueByUuid, () => { setDetailsReload(r => !r); }, true);

    useEffect(() => {
        getSettingsApi.execute({
            venueUuid
        });
    }, [reload]);

    useEffect(() => {
        if (initRef.current === 1) {
            initRef.current = 2;
            setInitVal(initRef.current);
        } else {
            updateVenueApi.execute({
                cancellation_enable: cancellationCheck ? 1 : 0,
                slot_duration: slotDuration
            }, venueUuid);
        }
    }, [slotDuration, cancellationCheck]);

    return (
        <Grid container direction="column" spacing={3}>
            <Grid item xs={12}>
                <Grid container direction="column" spacing={0}>
                    <Grid item>
                        <Typography variant="subtitle1">Slot Configuration</Typography>
                    </Grid>
                    <Grid sx={{ marginTop: '10px' }}>
                        <FormControl size="medium" sx={{ width: '30%' }}>
                            <InputLabel id="slot-duration-select-label">Slot Duration</InputLabel>
                            <Select
                                labelId="slot-duration-select-label"
                                id="slot-duration-select"
                                label="Time Duration"
                                name="slot_duration"
                                value={slotDuration}
                                onChange={changeDuration}
                            >
                                {
                                    SLOT_DURATION.map((slotDuration, index) => {
                                        return (
                                            <MenuItem key={index} value={slotDuration.value}>{slotDuration.name}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Grid container direction="column" spacing={0}>
                    <Grid item>
                        <Typography variant="subtitle1">Settings</Typography>
                    </Grid>
                    <Grid item>
                        <FormControlLabel
                            control={
                                <Switch checked={cancellationCheck} onChange={handleCancellation} name="cancellationCheck" color="primary" />
                            }
                            label="Enable Cancellation"
                        />
                    </Grid>
                    <Grid item>
                        <Typography variant="subtitle1">
                            Update Venue Content
                            <IconButton
                                color="primary"
                                onClick={() => handleClickOpen('venue_content')}
                                size="large"
                            >
                                <ContentPasteIcon sx={{ fontSize: '1.3rem', marginBottom: '2px' }} />
                            </IconButton>
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="subtitle1">
                            Update Venue Terms
                            <IconButton
                                color="primary"
                                onClick={() => handleClickOpen('venue_terms')}
                                size="large"
                            >
                                <ContentPasteIcon sx={{ fontSize: '1.3rem', marginBottom: '2px' }} />
                            </IconButton>
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="subtitle1">
                            Update Venue Terms & Conditions
                            <IconButton
                                color="primary"
                                onClick={() => handleClickOpen('venue_terms_conditions')}
                                size="large"
                            >
                                <ContentPasteIcon sx={{ fontSize: '1.3rem', marginBottom: '2px' }} />
                            </IconButton>
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <VenueContent
                open={open}
                handleClose={handleClose}
                setReload={setReload}
                selectedContent={selectedContent}
                rows={rows}
                venueUuid={venueUuid}
            />
        </Grid>
    );
};